import React, { useEffect, useState } from "react";
import * as incpectionAction from "../../../redux/actions/incpectionAction";
import { useDispatch, useSelector } from "react-redux";
import InspectionSetList from "../component/inspection/inspectionSetList";
import { useNavigate } from "react-router-dom";
import {
  ACCESS_DENIED,
  INSPECTION_SET,
  INSPECTIONS,
} from "../../../constant/routeContant";
import { ORG_ID } from "../../../constant/constant";
import Loader from "../../../library/common/Loader";
import { ToastContainer, toast } from "react-toastify";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { InactiveClient } from "../../../utils/helper";
import { getPreviousRoute } from "../../../utils/routeTracker";

const SetConfigurationListContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [shouldRestoreState, setShouldRestoreState] = useState(null);

  const addInspection = () => {
    if (InactiveClient()) return;
    navigate(INSPECTION_SET);
  };

  const cloneQuestionSet = useSelector((state) => state.cloneQuestionSet);

  const questionSetList = useSelector((state) => state.getQuestionSetList);

  const questionSetListData = (data) => {
    dispatch(incpectionAction.getQuestionSetList(data));
    dispatch(incpectionAction.getIncpectionFormsFilterObj(data));
  };
  const isLoading = useSelector((state) => state.getQuestionSetList?.isLoading);

  const defaultQuestionSetData = {
    organisationId: ORG_ID(),
    isActive: "",
  };
  const [clearStatus, setClearStatus] = useState(false);
  const [clearClone, setClearClone] = useState(false);

  const adminAddUpdateInspection = useSelector(
    (state) => state.adminAddUpdateInspection
  );
  const showLoader = useSelector(
    (state) =>
      state.adminAddUpdateInspection?.isLoading ||
      state.cloneQuestionSet?.isLoading
  );

  const onSubmit = (data) => {
    if (InactiveClient()) return;
    setClearStatus(true);
    dispatch(incpectionAction.adminAddUpdateInspection(data));
  };

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [INSPECTIONS, INSPECTION_SET];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("inspectionSetListPreserveState") === "true";
    sessionStorage.removeItem("inspectionSetListPreserveState");

    dispatch(incpectionAction.clearCloneQuestionSet());
    dispatch(incpectionAction.clearAdminAddUpdateInspection());
    if (isFromPreserveRoute && questionSetList?.filterObj) {
      setShouldRestoreState(true);
      questionSetListData(questionSetList.filterObj);
    } else {
      setShouldRestoreState(false);
      questionSetListData(defaultQuestionSetData);
    }
  }, []);

  useEffect(() => {
    if (
      adminAddUpdateInspection?.status === "SUCCESS" &&
      adminAddUpdateInspection?.isLoading === false &&
      clearStatus
    ) {
      toast("Inspection Updated successfully");
      const currentFilterData = questionSetList?.filterObj || defaultQuestionSetData;
      questionSetListData(currentFilterData);
    }
  }, [adminAddUpdateInspection]);

  const handleEditOnClick = (questsetId, assetTypeId) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("inspectionSetListPreserveState", "true");
    navigate(INSPECTION_SET, {
      state: {
        questsetId: questsetId,
        assetTypeId: assetTypeId,
        editMode: true,
      },
    });
  };

  const handleCloneOnClick = (questsetId) => {
    if (InactiveClient()) return;
    navigate(INSPECTION_SET, {
      state: { questsetId: questsetId, cloneMode: true },
    });
  };

  const onCloneSubmit = (data) => {
    if (InactiveClient()) return;
    setClearClone(true);
    dispatch(incpectionAction.cloneQuestionSet(data));
  };

  useEffect(() => {
    if (
      cloneQuestionSet?.status === "SUCCESS" &&
      cloneQuestionSet?.isLoading === false &&
      clearClone
    ) {
      toast("Clone Inspection Name Added successfully");
      const currentFilterData = questionSetList?.filterObj || defaultQuestionSetData;
      questionSetListData(currentFilterData);
    }
  }, [cloneQuestionSet]);


  return (
    <>
      {checkPrivileges([12, 120, 121, 122, 4]) ? (
        <>
          <>{showLoader && <Loader />}</>

          <InspectionSetList
            addInspection={addInspection}
            isLoading={isLoading}
            questionSetList={
              isLoading ? [] : questionSetList?.data?.questionsSets
            }
            handleEditOnClick={handleEditOnClick}
            handleCloneOnClick={handleCloneOnClick}
            onSubmit={onSubmit}
            onCloneSubmit={onCloneSubmit}
            questionSetListData={questionSetListData}
            questionSetLists={questionSetList}
            shouldRestoreState={shouldRestoreState}
          />
          <ToastContainer />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default SetConfigurationListContainer;
